import React from 'react';
export function Footer() {
  return <footer className=<div className="max-w-2xl mx-auto text-center" data-id="element-155">
        <p className="text-gray-400 text-sm font-body" data-id="element-156">
          © MegaPack TDAH en Retroceso
        </p>
        <p className="text-gray-500 text-xs font-body mt-1" data-id="element-157">
          Todos los derechos reservados
        </p>
      </div> data-id="element-154"></footer>;
}